import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ReviewCarousel = ({ content }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sliderRef = useRef(null);
  const componentRef = useRef(null);

  // Fade-in on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (componentRef.current) {
        const top = componentRef.current.getBoundingClientRect().top;
        if (top < window.innerHeight) setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1, // ✅ single slide always
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 600,
    pauseOnHover: true,
    appendDots: dots => (
      <div>
        <ul className="flex absolute -bottom-5 left-1/2 -translate-x-1/2">{dots}</ul>
      </div>
    ),
    customPaging: i => (
      <div className="w-4 h-4 bg-gray-400 rounded-full mx-2 transition-all duration-300 hover:bg-[#FEE600]"></div>
    ),
  };

  return (
    <div
      className={`w-full bg-black py-20 transition-opacity duration-500 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
      ref={componentRef}
    >
      {/* Title */}
      <h2 className="lg:text-6xl md:text-3xl text-xl lg:px-[100px] md:px-[60px] px-[30px] mt-10 mb-20 font-bold text-white">
        {content.title}
      </h2>

      {/* Carousel */}
      <div className="w-full mx-auto px-4">
        <Slider ref={sliderRef} {...settings}>
          {content.data.map((review, index) => (
            <div key={index} className="px-3">
              <div className="text-white p-6 md:p-10 rounded-lg border border-yellow-500 h-[300px] flex flex-col justify-between">
                <div>
                  <h3 className="text-lg md:text-2xl mb-2 font-semibold">
                    {review.title}
                  </h3>
                  <p className="text-xs md:text-sm text-slate-300 line-clamp-3">
                    {review.description}
                  </p>
                </div>
                <div className="text-sm text-slate-300">
                  {review.postedby.company}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ReviewCarousel;
